// import { Modal } from "./modal";
// import { Slider } from "./objects/slider";
// import { BalanceBox } from "./objects/balanceBox";
import { WebSocketManager } from "../../helpers/webSocketManager";
// import { PieTimer } from "./objects/pieTimer";
// import { Parser } from "../../helpers/parser";
// import Button from "./objects/button";
// import { AutoBuyIn } from "./objects/autoBuyIn";
// import { tweenConfigs } from "../../helpers/tweensConfigs";
import { store } from "@/store/store";

// export class ReservingModal extends Modal {
export class ReservingModal {
  /**
   * @param scene {GameScene}
   * @param table {Table}
   * @param balance {number} userBalance
   */
  constructor(scene, table, balance) {
    // super(scene);
    this.scene = scene;
    this.table = table;
    this.tableInfo = table.tableInfo;
    // this.isShowing = false;

    this.buyInInfo = {
      balance: 0,
      maxBuyIn: 0,
      minBuyIn: 0,
      canBuyIn: true,
      remainingTime: 0,
    };
    // this.bg = this.scene.add
    //   .sprite(0, 0, this.scene.atlasTexture, "reserve-modal-bg")
    //   .setOrigin(0)
    //   .setInteractive();
    // this.bg.on("pointerdown", this.blurTextInput, this);

    // this.sliderValueText = this.scene.add.bitmapText(
    //   0,
    //   0,
    //   "myRaid",
    //   "123456789135464797"
    // );
    // this.sliderValueText.setData("width", this.sliderValueText.width);
    // this.sliderValueText.setData("height", this.sliderValueText.height);
    // this.sliderValueText.setInteractive();
    // this.sliderValueText.on(
    //   "pointerdown",
    //   this.onPointerDownOnSliderValueText,
    //   this
    // );

    // this.sliderValueInput = this.scene.add
    //   .rexInputText(0, 0, 0, 0, {
    //     id: "sliderValueInput",
    //     type: "number",
    //     text: 0,
    //     fontSize: "10px",
    //     // backgroundColor: 'white',
    //     // color: 'black',
    //     color: "white",
    //     fontFamily: "myRaid",
    //     align: "center",
    //   })
    //   .on("textchange", (inputText, e) => {
    //     // console.log(e.target.value);
    //     // this.slider.changeValue(e.target.value);
    //     // this.sliderValueInput.setText(e.target.value);
    //     // this.changeSliderValueText(e.target.value);
    //     this.slider.changeValue(e.target.value);
    //   })
    // .on("focus", (inputText, e) => {
    //   inputText.text = Parser.decodeAmount(e.target.value);
    // })
    // .setVisible(false);
    // this.addStyleForRemoveNumberInputArrows();

    // this.balanceBox = new BalanceBox(this.scene, this.buyInInfo.balance);
    // this.autoBuyIn = new AutoBuyIn(this.scene);

    // this.button = new Button(this.scene, "reserve-modal-btn", true);
    // this.button.on("pointerup", this.doConfirm, this); //D
    // this.slider = new Slider(
    //   scene,
    //   this,
    //   this.buyInInfo.maxBuyIn,
    //   this.buyInInfo.minBuyIn
    // );

    // this.timer = new PieTimer(this.scene);

    // this.alertBg = this.scene.add
    //   .rectangle(0, 0, 0, 0, 0x26374c)
    //   .setDepth(this.bg.depth + 1)
    //   .setVisible(false);
    // this.alertText1 = this.scene.add
    //   .bitmapText(0, 0, "myRaid", "Your current balance: 100,000,000")
    //   .setVisible(false);
    // this.alertText1.setData("width", this.alertText1.width);
    // this.alertText1.setData("height", this.alertText1.height);
    // this.alertText2 = this.scene.add
    //   .bitmapText(0, 0, "myRaid", "Minimum buy-in: 100,000,000")
    //   .setVisible(false);
    // this.alertText2.setData("width", this.alertText2.width);
    // this.alertText2.setData("height", this.alertText2.height);
    // this.alertText3 = this.scene.add
    //   .bitmapText(0, 0, "myRaid", `You don't have enough money to reserve.`)
    //   .setVisible(false);
    // this.alertText3.setData("width", this.alertText3.width);
    // this.alertText3.setData("height", this.alertText3.height);

    // this.children = this.scene.add.group();
    // this.children.addMultiple([
    //   this.bg,
    //   this.closeButton,
    //   this.sliderValueInput,
    //   this.sliderValueText,
    //   ...this.slider.children.getChildren(),
    //   ...this.balanceBox.children.getChildren(),
    //   ...this.autoBuyIn.children.getChildren(),
    //   this.button,
    //   ...this.timer.children.getChildren(),
    //   this.alertBg,
    //   this.alertText1,
    //   this.alertText2,
    //   this.alertText3,
    // ]);
    // Phaser.Actions.SetDepth(this.children.getChildren(), 101);
    // this.children.getChildren()[1].setDepth(102); /* close button */
    // Phaser.Actions.SetAlpha(this.children.getChildren(), 0);
    // this.closeButton.on("pointerup", this.onCloseButtonClick, this); //D
    // this.overlay.on("pointerdown", this.blurTextInput, this);
    // this.reserveSeatPosition = 0;
    // this.loading = false;
    // this.initX = 0;
    // this.tableWidth = 0;
    // this.showInProgress = false;
  }
  // onCloseButtonClick() {
  //   this.closeButton.disableInteractive();
  //   this.closeButton.onClick(() => {
  //     this.leaveTable()
  //       .then(() => this.closeButton.enableInteractive())
  //       .catch(() => this.closeButton.enableInteractive());
  //   });
  // }
  // onPointerDownOnSliderValueText() {
  //   this.sliderValueText.setVisible(false);
  //   this.sliderValueInput.setText(this.buyInValue);
  //   this.sliderValueInput.setVisible(true);
  // }
  // blurTextInput() {
  //   this.sliderValueInput.setVisible(false);
  //   this.slider.changeValue(this.buyInValue);
  //   this.sliderValueText.setVisible(true);
  // }
  // changeSliderValueText(amount) {
  //   this.buyInValue = amount;
  //   this.sliderValueText.text = amount.toLocaleString();
  //   this.sliderValueText.setX(
  //     this.initX + (this.tableWidth - this.sliderValueText.width) / 2
  //   );
  // }
  // addStyleForRemoveNumberInputArrows() {
  //   let style = document.createElement("style");
  //   style.innerHTML = `
  //       #sliderValueInput::-webkit-inner-spin-button,
  //       #sliderValueInput::-webkit-outer-spin-button {
  //         -webkit-appearance: none;
  //         margin: 0;
  //       }`;
  //   document.head.appendChild(style);
  // }
  // doConfirm() {
  //   this.button.onClick(() => {
  //     this.button.disableInteractive();
  //     this.blurTextInput();
  //     WebSocketManager.emitEvent(
  //       {
  //         clubId: this.scene.getURLClubId(),
  //         tableId: this.table.tableInfo.id,
  //         buyIn: this.buyInValue,
  //         position: this.reserveSeatPosition,
  //         autoRebuy: this.autoBuyIn.checkBoxValue,
  //         rebuyAt: this.autoBuyIn.checkBoxValue ? this.autoBuyIn.inputValue : 1,
  //         password: "",
  //       },
  //       "poker.client-push.join-table"
  //     )
  //       .then(() => {
  //         this.hide().then(() => this.button.enableInteractive());
  //       })
  //       .catch((e) => {
  //         console.error(e);
  //         this.button.enableInteractive();
  //       });
  //   });
  // }
  // leaveTable() {
  //   return new Promise((resolve, reject) => {
  //     WebSocketManager.emitEvent(
  //       {
  //         tableId: this.table.tableInfo.id,
  //       },
  //       "poker.client-push.leave"
  //     )
  //       .then(() => {
  //         this.hide().then(() => resolve());
  //       })
  //       .catch((e) => {
  //         console.error(e);
  //         reject();
  //       });
  //   });
  // }
  showReservingModal(table, playerInfo) {
    store.commit("setReservingModalShow", true);
    store.commit("setTableInfo", table);
    store.commit("setPlayerInfo", playerInfo);
    this.scene.changeObjectsInteractivity(false);
  }
  /**
   * @param table{Table}
   * @param playerInfo
   * @param showTimer{boolean}
   */
  async show(table, playerInfo) {
    // this.showInProgress = true;
    this.reserveSeatPosition = playerInfo.position;
    // this.button.enableInteractive();
    /* hengam nemayesh modal bayad hatmn aval table ra update konim */
    try {
      await this.pullTableBuyIn(table);
      this.table = table;
      this.showReservingModal(table, playerInfo);
    } catch (error) {
      console.log("error in getting the table buy-in.");
    //   console.log(error);
    }
    // this.updateInfo();
    // this.positionControls(
    //   this.table.displayWidth,
    //   this.table.displayHeight,
    //   this.table.x,
    //   this.table.y
    // );
    // this.autoBuyIn.init();
    // this.blurTextInput();
    // this.timer.visibilityControls(showTimer);
    // if (!this.buyInInfo.canBuyIn) this.showAlert();
    // else this.hideAlert();
    // const childrenToShow = [
    //   this.bg,
    //   this.closeButton,
    //   this.sliderValueInput,
    //   this.sliderValueText,
    //   ...this.slider.children.getChildren(),
    //   ...this.balanceBox.children.getChildren(),
    //   this.button,
    //   this.autoBuyIn.cover,
    //   ...this.timer.children.getChildren(),
    //   this.alertBg,
    //   this.alertText1,
    //   this.alertText2,
    //   this.alertText3,
    // ];
    // this.scene.tweens.add({
    //   targets: childrenToShow,
    //   // delay: 100,
    //   duration: tweenConfigs.modal.show.duration,
    //   ease: tweenConfigs.modal.show.ease,
    //   alpha: 1,
    //   onComplete: () => {
    //     this.isShowing = true;
    //     this.showInProgress = false;
    //     this.autoBuyIn.visibilityControls(false);
    //     this.autoBuyIn.input.setAlpha(1);
    //   },
    // });
    // if (showTimer) this.timer.startTimer(this.buyInInfo.remainingTime);
    // this.modalShow();
  }
  hide() {
    // return new Promise((resolve) => {
    // this.scene.tweens.add({
    //   targets: this.children.getChildren(),
    //   duration: tweenConfigs.modal.hide.duration,
    //   ease: tweenConfigs.modal.hide.ease,
    //   alpha: 0,
    //   onComplete: () => {
    //     this.isShowing = false;
    //     resolve();
    //   },
    // });
    // this.modalHide();
    this.scene.changeObjectsInteractivity(true);
    store.commit("setReservingModalShow", false);
    // });
  }
  // updateInfo() {
  //   this.slider.changeLimits(this.buyInInfo.maxBuyIn, this.buyInInfo.minBuyIn);
  //   this.balanceBox.changeBalance(this.buyInInfo.balance);
  // }
  async pullTableBuyIn(table) {
    try {
      const reserveInfo = await WebSocketManager.emitEvent(
        {
          tableId: table.tableInfo.id,
          clubId: table.gameState.playerInfo.clubId,
        },
        "poker.client-pull.table-buy-in"
      );
      await store.commit("setReserveInfo", reserveInfo);
    } catch (e) {
      console.error(e);
    }
  }
  // showAlert() {
  //   this.alertBg.setVisible(true);
  //   Phaser.Actions.SetVisible(
  //     [
  //       ...this.balanceBox.children.getChildren(),
  //       this.sliderValueInput,
  //       this.sliderValueText,
  //       ...this.slider.children.getChildren(),
  //       // this.checkBox.check,
  //       this.button,
  //     ],
  //     false
  //   );
  //   this.alertText1.setText(
  //     `Your current balance: ${this.buyInInfo.balance.toLocaleString()}`
  //   );
  //   this.alertText1.setX(
  //     this.bg.x + (this.bg.displayWidth - this.alertText1.width) / 2
  //   );
  //   this.alertText1.setVisible(true);

  //   this.alertText2.setText(
  //     `Minimum buy-in: ${this.buyInInfo.minBuyIn.toLocaleString()}`
  //   );
  //   this.alertText2.setX(
  //     this.bg.x + (this.bg.displayWidth - this.alertText2.width) / 2
  //   );
  //   this.alertText2.setVisible(true);

  //   this.alertText3.setVisible(true);
  // }
  // hideAlert() {
  //   if (this.alertBg.visible) {
  //     this.alertBg.setVisible(false);
  //     Phaser.Actions.SetVisible(
  //       [
  //         ...this.balanceBox.children.getChildren(),
  //         this.sliderValueText,
  //         ...this.slider.children.getChildren(),
  //         // this.checkBox.check,
  //         this.button,
  //       ],
  //       true
  //     );
  //     this.alertText1.setVisible(false);
  //     this.alertText2.setVisible(false);
  //     this.alertText3.setVisible(false);
  //   }
  // }
  /***
   * @param width {number} width of table
   * @param height {number} width of table
   * @param initX {number} table top left x
   * @param initY {number} table top left y
   */
  // positionControls(width, height, initX, initY) {
  //   this.initX = initX;
  //   this.tableWidth = width;
  //   const bgSize = width;
  //   const bgScale = localScaleManager.scaleSprite(
  //     this.bg,
  //     bgSize,
  //     bgSize,
  //     0,
  //     1,
  //     true
  //   );
  //   localScaleManager.scaleSpriteTo(this.bg, bgScale);
  //   this.bg.setPosition(
  //     initX + (width - this.bg.displayWidth) / 2,
  //     initY + (height - this.bg.displayHeight) / 2
  //   );

  //   localScaleManager.scaleBitMapText(
  //     this.sliderValueText,
  //     width / 2,
  //     height / 16,
  //     Math.min(this.sliderValueText.width, this.sliderValueText.height) * 0.2,
  //     1,
  //     false
  //   );
  //   this.sliderValueText.setPosition(
  //     initX + (width - this.sliderValueText.width) / 2,
  //     initY + height / 2.8
  //   );

  //   this.sliderValueInput.resize(
  //     this.bg.displayWidth / 1.5,
  //     this.bg.displayWidth / 10
  //   );
  //   this.sliderValueInput.setStyle("fontSize", `${(width / 7) * 0.35}px`);
  //   this.sliderValueInput.setPosition(
  //     initX + this.bg.displayWidth / 2.5,
  //     initY + height / 2.85
  //   );
  //   this.slider.positionControls(
  //     width / 12,
  //     width / 2,
  //     initX + width / 2,
  //     initY + height / 2.3,
  //     width / 2,
  //     height / 50
  //   );
  //   this.timer.positionControls(
  //     this.bg.displayWidth / 6,
  //     this.bg.x + this.bg.displayWidth / 2,
  //     this.bg.y + this.bg.displayWidth / 4
  //   );

  //   this.balanceBox.positionControls(width, height, initX, initY);
  //   this.autoBuyIn.positionControls(
  //     this.bg.displayWidth,
  //     this.bg.displayHeight,
  //     this.bg.x,
  //     this.bg.y
  //   );
  //   this.modalPositionControls(this.bg.x, this.bg.y, this.bg.displayWidth);

  //   const btnSize = width / 2.5;
  //   const btnScale = localScaleManager.scaleSprite(
  //     this.button,
  //     btnSize,
  //     btnSize,
  //     0,
  //     1,
  //     true
  //   );
  //   localScaleManager.scaleSpriteTo(this.button, btnScale);
  //   this.button.setPosition(
  //     initX + width / 2,
  //     this.bg.y + this.bg.displayHeight - this.button.displayHeight / 1.1
  //   );

  //   this.alertBg.width = this.bg.displayWidth * 0.9;
  //   this.alertBg.height = this.bg.displayHeight * 0.55;
  //   this.alertBg.setPosition(
  //     this.bg.x + (this.bg.displayWidth - this.alertBg.width) / 2,
  //     this.bg.y + (this.bg.displayHeight - this.alertBg.height) / 2
  //   );

  //   localScaleManager.scaleBitMapText(
  //     this.alertText1,
  //     width / 2,
  //     height / 16,
  //     Math.min(this.alertText1.width, this.alertText1.height) * 0.2,
  //     1,
  //     false
  //   );
  //   this.alertText1.setPosition(
  //     initX + (width - this.alertText1.width) / 2,
  //     initY + height / 2.4
  //   );

  //   localScaleManager.scaleBitMapText(
  //     this.alertText2,
  //     width / 2,
  //     height / 16,
  //     Math.min(this.alertText2.width, this.alertText2.height) * 0.2,
  //     1,
  //     false
  //   );
  //   this.alertText2.setPosition(
  //     initX + (width - this.alertText2.width) / 2,
  //     initY + height / 2.2
  //   );

  //   localScaleManager.scaleBitMapText(
  //     this.alertText3,
  //     width / 2,
  //     height / 16,
  //     Math.min(this.alertText3.width, this.alertText3.height) * 0.2,
  //     1,
  //     false
  //   );
  //   this.alertText3.setPosition(
  //     initX + (width - this.alertText3.width) / 2,
  //     initY + height / 2
  //   );
  // }
}
